export default __webpack_public_path__ + "static/media/deleteIcon.44a59ab2.svg";